import { AnyAction } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";

import { IService } from "../../serviceOrdering/reducers";
import * as Constants from "../constants";
import * as Service from "../services";

function* getService(action: AnyAction) {
  try {
    const payload: IService = yield call(Service.getService, action.id);
    yield put({
      type: Constants.GET_SERVICE_SUCCESS,
      payload,
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_SERVICE_FAILED, e });
    return action.reject(e);
  }
}
function* updateService(action: AnyAction) {
  try {
    const response: any = yield call(
      Service.updateService,
      action.id,
      action.service,
    );
    response.data.message
      ? action.resolve()
      : action.reject(response.data.message);
  } catch (e) {
    action.reject(e);
  }
}
function* updateStatus(action: AnyAction) {
  try {
    const response: any = yield call(
      Service.updateStatus,
      action.slug,
      action.serviceId,
    );
    action.resolve(true);
  } catch (e) {
    action.reject(e);
  }
}
export const OrderViewSagas = [
  takeLatest(Constants.UPDATE_STATUS, updateStatus),
  takeLatest(Constants.UPDATE_SERVICE, updateService),
  takeLatest(Constants.GET_SERVICE, getService),
];
